import { getItems, replaceURLDomain } from '@portal-internet/core';
import { getData } from '@portal-internet/bff';
import Destacat from 'components/3cat/Destacat';
import ErrorBoundary from 'components/3cat/ErrorBoundary';
import { useQuery } from 'react-query';

export default function DestacatWrapper(props) {
    const { tipus, prefetchedData, id, urlDadesByProducte, field, dataTestId, tema } = props;
    const initialData = prefetchedData?.[id] ? prefetchedData?.[id] : null;
    const urlDades = replaceURLDomain(urlDadesByProducte);
    const { data } = useQuery([field + id, { url: urlDades }], getData, {
        initialData: initialData,
        staleTime: Infinity,
        refetchOnMount: !initialData ? 'always' : false
    });
    const items = getItems(data);
    const item = items?.[0];

    return item ? (
        <ErrorBoundary hideError={true}>
            <Destacat
                supertitol=''
                avantitol={item?.avantitol}
                titolPrograma={
                    item?.programes_tv?.[0]?.titol ||
                    item?.programes_radio?.[0]?.titol ||
                    item?.programes_tv?.[0]?.desc ||
                    item?.programes_radio?.[0]?.desc
                }
                titolPromo={item.titol_promo}
                titol={item.titol}
                imatges={item.imatges}
                imatgesPrograma={item?.programes_tv?.[0]?.imatges || item?.programes_radio?.[0]?.imatges}
                entradeta={item.entradeta}
                entradetaPromo={item.entradeta_promo}
                nombonic={item.nombonic}
                tipus='SUPERDESTACAT'
                durada={item.durada}
                codiEspectador={item.codis_etics}
                tipologia={item.tipologia}
                etiqueta={item.etiquetes?.find((et) => et.main === true)?.desc || item.etiqueta}
                tipologiaRelacionada={item?.programes?.[0]?.tipologia}
                linkId={item.id}
                dataTestId={dataTestId}
                format={item.format}
                formats={item.formats}
                dataCaducitat={item.data_caducitat}
                callToAction={item?.call_to_action}
                link={item?.url}
                tema={tema}
            />
        </ErrorBoundary>
    ) : null;
}
